export default require("content/lib/models/content").default({
  type: "submission",
  is_complete: false
})
